import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import * as RequestTypes from 'Request-Types/constants';
import * as AuthActionType from '../../Auth/constants';
import {Dropdown} from 'components/Dropdown/Dropdown';
import * as RFSActionType from '../constants';
import * as ProjectActionType from 'Projects/constants';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import Translate from 'components/translate';

class ReviewRFS extends React.Component {
  static propTypes = {
    RFSInformation: PropTypes.object,
    requestTypeList: PropTypes.array,
    userList: PropTypes.array,
    dispatch: PropTypes.func,
    adminSelectList: PropTypes.array,
    userSelectList: PropTypes.array,
    onToggleReviewRFS: PropTypes.func,
    onReviewRfsSuccess: PropTypes.func,
    rfsId: PropTypes.any
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  // componentDidMount() {
  //   this.props.dispatch({
  //     type: RFSActionType.GET_BY_RFS_ID_ASYNC,
  //     params: this.props.rfsId
  //   });
  // }

  fetchRequestType = () => {
    this.setState({
      isFetchingRequestType: true
    });
    this.props.dispatch({
      type: RequestTypes.SELECT_LIST_ITEM_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        isBlueTape: false
      },
      callback: () => {this.setState({isFetchingRequestType: false});}
    });
  }

  fetchUser = () => {
    this.setState({
      isFetchingUser: true
    });
    if (this.state.check) {
      this.props.dispatch({
        type: AuthActionType.SELECT_LIST_ADMIN_SUPER_ADMIN_ASYNC,
        params: {
          searchKey: '',
          selectedValue: ''
        },
        callback: () => {this.setState({isFetchingUser: false});}
      });
    } else {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_USER_ASYNC,
        params: {
          projectId: this.props.RFSInformation.project.id
        },
        callback: () => {this.setState({isFetchingUser: false});}
      });
    }
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
  }

  onChecked = () => {
    this.setState({
      check: !this.state.check
    });
  }

  onSubmit = () => {
    const { RFSInformation } = this.props;
    let requestTypeId = '';
    let managedByUserId = '';

    if (this.state.user) {
      managedByUserId = this.state.user.value;
    } else {
      managedByUserId = RFSInformation.managedByUser.id;
    }

    if (this.state.requestType) {
      requestTypeId = this.state.requestType.value;
    } else {
      requestTypeId = RFSInformation.requestType.id;
    }

    this.props.dispatch({
      type: RFSActionType.UPDATE_RFS_WITHOUT_CHANGE_STATUS_ASYNC,
      params: {
        data: {
          requestTypeId,
          managedByUserId
        },
        refNo: RFSInformation.refNo
      },
      callback: () => {
        this.props.onToggleReviewRFS();
        if (this.props.onReviewRfsSuccess) {
          this.props.onReviewRfsSuccess();
        }
      }
    });
  }

  renderGeneralInformation = () => {
    let {requestType, user} = this.state;
    const { RFSInformation } = this.props;
    let userSelectList = [];
    if (isEmpty(this.props.adminSelectList) && isEmpty(this.props.userList)) {
      userSelectList = [{value: RFSInformation.managedByUser.id, text: RFSInformation.managedByUser.displayName}];
    } else {
      userSelectList = this.state.check ? this.props.adminSelectList : this.props.userList;
    }

    if (isEmpty(user)) {
      user = {value: RFSInformation.managedByUser.id, text: RFSInformation.managedByUser.displayName};
    }

    if (isEmpty(requestType)) {
      requestType = {value: RFSInformation.requestType.id, text: RFSInformation.requestType.name};
    }

    return <div style={{padding: 15}}>
      {/* left-column */}
      <div className='col-sm-6'>
        <div className='row'>
          <div className='form-group'>
            <label className='col-lg-3 col-sm-4 control-label'>Status</label>
            <div className='col-lg-9 col-sm-8 control-label name form-text-label'>
              <strong>{RFSInformation.statusValue}</strong>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-lg-3 col-sm-4 control-label'><Translate translateKey='project' capitalize /></label>
            <div className='col-lg-9 col-sm-8 control-label name form-text-label'>
              <strong>{RFSInformation.project.name}</strong>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-lg-3 col-sm-4 control-label'><Translate translateKey='lot' capitalize /># - Address</label>
            <div className='col-lg-9 col-sm-8 control-label name form-text-label'>
              <strong>{RFSInformation.lot.name} - {RFSInformation.lot.streetAddress}</strong>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-lg-3 col-sm-4 control-label'>RFS managed by</label>
            <div className='col-lg-9 col-sm-8 control-label name form-text-label'>
              <Dropdown
                filter={true}
                onChange={ref => {this.onSelectChange(ref, 'user');}}
                className='filestring-dropdown filter-dropdown'
                placeholder='Please select'
                onRemote={this.fetchUser}
                options={userSelectList}
                loading={this.state.isFetchingUser}
                value={user}
                optionLabel='text'
                style={{width: '100%', marginBottom: 0}}
              />
              <CheckBoxSingle
                style={{marginTop: 0, marginBottom: 20}}
                checked={this.state.check}
                ref={c => { this.check = c; }}
                name='checkAdmin'
                label='I want to assign this request to admin'
                className='checkbox-default noteTitle'
                onChecked={this.onChecked} />
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-lg-3 col-sm-4 control-label'>Request type</label>
            <div className='col-lg-9 col-sm-8 control-label name form-text-label'>
              <Dropdown
                filter={true}
                onChange={ref => {this.onSelectChange(ref, 'requestType');}}
                className='filestring-dropdown filter-dropdown'
                placeholder='Please select'
                options={isEmpty(this.props.requestTypeList) ? [{value: RFSInformation.requestType.id, text: RFSInformation.requestType.name}] : this.props.requestTypeList}
                loading={this.state.isFetchingRequestType}
                style={{width: '100%'}}
                optionLabel='text'
                onRemote={this.fetchRequestType}
                value={requestType}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-sm-12 form-group'>
          <div className='col-sm-12' style={{padding: 0}}>
            <a className='btn btn-primary btn-siteone-default btn-wo-edit' onClick={this.props.onToggleReviewRFS}>Cancel</a>
            <button className='btn btn-siteone' onClick={this.onSubmit}>Save</button>
          </div>
        </div>
      </div>

    </div>;
  }

  render() {
    return (
      <div className='rfs-wrapper col-sm-12 box-form-siteone'>
        {this.renderGeneralInformation()}

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    requestTypeList: state.RequestTypeStore.ItemList,
    userList: state.ProjectStore.UserSelectList,
    adminSelectList: state.authReducer.adminSelectList
  };
};

export default connect(mapStateToProps)(ReviewRFS);




// WEBPACK FOOTER //
// ./src/Request-Services/Components/ReviewRFS.js